import {Component, OnDestroy, OnInit} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {forkJoin, Observable, Subject} from "rxjs";
import * as XLSX from "xlsx";
import {CounselingService} from "../../counseling/counseling.service";
import {EmployeeService} from "../../../services/employee.service";
import {CentreService} from "../../../services/centre.service";
import {Centre} from "../../../interfaces/Centres";
import {FormControl} from "@angular/forms";
import {map, takeUntil} from 'rxjs/operators';
import {LoadingService} from "../../../services/loading.service";
import {PermissionType} from "../../../components/employee/PermissionType.enum";
import {endOfDay} from '../../../utils/date-range-format.service';

interface AssessmentCount {
  teacher: string;
  centre: string;
  admissionBaselineCount: number | string;
  dischargeAssessmentCount: number | string;
  intermediateAssessmentCount: number | string;
}

@Component({
    selector: 'app-counselling-session-count-report',
    templateUrl: './counselling-session-count-report.component.html',
    styleUrls: ['./counselling-session-count-report.component.scss']
})
export class CounsellingSessionCountReportComponent implements OnInit, OnDestroy {
    private _destroyed$ = new Subject<void>();
    startDate!: Date | undefined | null;
    endDate!: Date | undefined | null;
    // selectedYear: number = 2024;
    selectedYear: number = new Date().getFullYear() - 1;
    submittedBy: string | undefined | null = 'All'
    selectedCentres: string[] = [];
    mData: any[] = []
    mGroupData: any[] = []
    mAssessmentData: any[] = []
    mFAssessmentData: any[] = []
    processedData = {};
    uniqueCentres: string[] = []
    centres$: Observable<any> | undefined;
    centre: any
    assessmentUniqueCentres: string[] = []
    fassessmentUniqueCentres: string[] = []
    tableData: any[] = []
    groupTableData: any[] = []
    assessmentTableData: any[] = []
    fassessmentTableData: any[] = []
    uniqueTecherData: any[] = []
    counsellors$: Observable<any[]>
    _centres$: Observable<Centre[]>
    centreControl = new FormControl('')
    groupUniqueCentres: any[] = []
    selectedCentre: string[] = []
    fileName = 'Counselling_Count_Report.xlsx';

    constructor(private readonly mFirestore: AngularFirestore,
                private readonly mEmployeeService: EmployeeService,
                private LoadingService: LoadingService,
                private readonly counselingService: CounselingService,
                private readonly centreService: CentreService,
    ) {
        this._centres$ = this.centreService.getAllCentres()
        this._centres$.pipe(takeUntil(this._destroyed$)).subscribe((c) => {
            this.groupUniqueCentres = []
            this.fassessmentUniqueCentres = []
            this.uniqueCentres = []
            this.groupUniqueCentres = []
            this.groupUniqueCentres = c.map(c => c.centreName)
            this.uniqueCentres = c.map(c => c.centreName)
            this.fassessmentUniqueCentres = c.map(c => c.centreName)
            this.assessmentUniqueCentres = c.map(c => c.centreName)
            // @ts-ignore
            c.forEach(cx => {
                this.selectedCentre.push(cx.centreName!!)

            })
        })

        this.counsellors$ = this.mEmployeeService.getCounsellers()
        this.setFinancialYear(this.selectedYear);
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    // Function to set the financial year
    setFinancialYear(year: number) {
        this.startDate = new Date(year, 3, 1); // April 1st of the selected year
        this.endDate = new Date(year + 1, 2, 31); // March 31st of the next year
        // Force change detection by wrapping in setTimeout
        setTimeout(() => {
        }, 0);
    }

    // Function to handle year change from UI
    onYearChange(event: any) {
        debugger
        this.selectedYear = event.value;
        this.setFinancialYear(this.selectedYear);
    }

    search2() {
        if (this.startDate != null && this.endDate != null) {

        }
    }

    search() {
        this.LoadingService.setLoading(true);  // Start loader immediately

        this.startDate = this.startDate ? this.startDate : new Date(this.selectedYear, 3, 1); // April 1st
        this.endDate = this.endDate ? this.endDate : new Date(this.selectedYear + 1, 2, 31); // March 31st

        let completedRequests = 0;
        const totalRequests = 4; // Number of Firebase calls

        const checkLoading = () => {
            completedRequests++;
            console.log('completedRequests Count', completedRequests)
            if (completedRequests === totalRequests) {
                this.LoadingService.setLoading(false); // Stop loader only when all requests are done
            }
        };

        // Fetching Counselling Sessions
        this.mFirestore.collection<any>('Counselling/allSessions/sessions',
            ref => ref.where('date', '>=', this.startDate)
                .where('type', '==', 'Regular Counselling')
                .where('date', '<=', endOfDay(this.endDate)))
            .valueChanges({idField: 'id'})
            .pipe(takeUntil(this._destroyed$))
            .subscribe(res => {
                this.mData = res;
                this.processCounsellingSessions();
                checkLoading(); // Call checkLoading after processing
            });

        // Fetching Group Sessions
        this.mFirestore.collection<any>('Counselling/allSessions/groupSessions',
            ref => ref.where('date', '>=', this.startDate)
                .where('date', '<=', endOfDay(this.endDate)))
            .valueChanges({idField: 'id'})
            .pipe(takeUntil(this._destroyed$))
            .subscribe(res => {
                this.mGroupData = res;
                this.processGroupSessions();
                checkLoading();
            });

        // Fetching Assessments
        this.mFirestore.collection<any>('Assessments/allAssessments/assessments',
            ref => ref.where('dateOfAssessment', '>=', this.startDate)
                .where('dateOfAssessment', '<=', endOfDay(this.endDate)))
            .valueChanges({idField: 'id'})
            .pipe(takeUntil(this._destroyed$))
            .subscribe(res => {
                this.mAssessmentData = res;

                this.processAssessments();
                checkLoading();
            });

        // Fetching Follow-Up Assessments
        // this.mFirestore.collection<any>('CounselingFollowUpAssessment',
        //   ref => ref.where('dateOfAssessment', '>=', this.startDate)
        //     .where('dateOfAssessment', '<=', endOfDay(this.endDate)))
        //   .valueChanges({idField: 'id'})
        //   .subscribe(res => {
        //     this.mFAssessmentData = res;
        //     this.processFollowUpAssessments();
        //     checkLoading();
        //   });
        // Fetching Follow-Up Assessments and Follow-Up Counselling Sessions
        const followUpAssessments$ = this.mFirestore.collection<any>('CounselingFollowUpAssessment',
            ref => ref.where('dateOfAssessment', '>=', this.startDate)
                .where('dateOfAssessment', '<=', endOfDay(this.endDate))
        ).get().pipe(
            map(querySnapshot => {
                return querySnapshot.docs.map(doc => {
                    const data = doc.data();

                    return {
                        id: doc.id,

                        submittedBy: data['submittedBy'],
                        dateOfAssessment: data['dateOfAssessment'], // Rename 'date' to 'dateOfAssessment'
                        centreName: data['centreName']
                    }
                });
            })
        );


        const followUpSessions$ = this.mFirestore.collection<any>('Counselling/allSessions/sessions', ref => ref
                .where('type', '==', 'Follow-up Counselling')
                .where('date', '>=', this.startDate)
                .where('date', '<=', endOfDay(this.endDate))
            // .select('submittedBy', 'date', 'centreName') // Select only the required fields
        ).get().pipe(
            map(querySnapshot => {
                return querySnapshot.docs.map(doc => {
                    const data = doc.data();
                    return {
                        id: doc.id,
                        submittedBy: data['submittedBy'],
                        dateOfAssessment: data['date'], // Rename 'date' to 'dateOfAssessment'
                        centreName: data['centreName']
                    }; // Type assertion
                });
            })
        );

        forkJoin([followUpAssessments$, followUpSessions$]).pipe(takeUntil(this._destroyed$)).subscribe({
            next: ([followUpAssessments, followUpSessions]) => {
                // Combine the data
                console.log(`${followUpAssessments.length} ${followUpSessions.length}`)
                this.mFAssessmentData = [...followUpAssessments];
                checkLoading();
                this.processFollowUpAssessments();
                console.log()
            },
            error: (err) => {
                console.error('Error fetching Follow-Up data:', err);
                // checkLoading();
            }
        });
    }


    processCounsellingSessions() {
        let uniqueTeachers = [...new Set(this.mData.map(child => child.submittedBy))];
        let data2: any[] = [];

        if (this.submittedBy !== 'All' && this.submittedBy) {
            uniqueTeachers = uniqueTeachers.filter(x => x === this.submittedBy);
        }

        uniqueTeachers.forEach(t => {
            this.uniqueCentres.forEach(c => {
                let obj = {
                    teacher: t,
                    centre: c,
                    count: this.mData.filter(child => child.submittedBy === t && child.centreName === c).length || '-'
                };
                data2.push(obj);
            });
        });

        this.tableData = this.formatTableData(data2);
    }
  formatAssessmentTableData(data: any[]) {
    return data.reduce((acc, curr) => {
      const existingTeacher = acc.find((item: any) => item.teacher === curr.teacher);
      const centreData = {
        centre: curr.centre,
        // Handle both regular count and assessment counts
        ...(curr.count !== undefined && { count: curr.count }),
        ...(curr.admissionBaselineCount !== undefined && { admissionBaselineCount: curr.admissionBaselineCount }),
        ...(curr.dischargeAssessmentCount !== undefined && { dischargeAssessmentCount: curr.dischargeAssessmentCount }),
        ...(curr.intermediateAssessmentCount !== undefined && { intermediateAssessmentCount: curr.intermediateAssessmentCount })
      };

      if (existingTeacher) {
        existingTeacher.centres.push(centreData);
      } else {
        acc.push({
          teacher: curr.teacher,
          centres: [centreData]
        });
      }
      return acc;
    }, []);
  }
    formatTableData(data: any[]) {
        return data.reduce((acc, curr) => {
            const existingTeacher = acc.find((item: any) => item.teacher === curr.teacher);
            if (existingTeacher) {
                existingTeacher.centres.push({
                    centre: curr.centre,
                    count: curr.count
                });
            } else {
                acc.push({
                    teacher: curr.teacher,
                    centres: [{
                        centre: curr.centre,
                        count: curr.count
                    }]
                });
            }
            return acc;
        }, []);

    }


    processGroupSessions() {
        let uniqueTeachers = [...new Set(this.mGroupData.map(child => child.submittedBy))];
        let data2: any[] = [];

        if (this.submittedBy !== 'All' && this.submittedBy) {
            uniqueTeachers = uniqueTeachers.filter(x => x === this.submittedBy);
        }

        uniqueTeachers.forEach(t => {
            this.groupUniqueCentres.forEach(c => {
                let obj = {
                    teacher: t,
                    centre: c,
                    count: this.mGroupData.filter(child => child.submittedBy === t && child.centres[0].centreName === c).length || '-'
                };
                data2.push(obj);
            });
        });

        this.groupTableData = this.formatTableData(data2);
    }

    processAssessments() {
        let uniqueTeachers = [...new Set(this.mAssessmentData.map(child => child.personConductingTest))];

        let data2: any[] = [];

        if (this.submittedBy !== 'All' && this.submittedBy) {
            uniqueTeachers = uniqueTeachers.filter(x => x === this.submittedBy);
        }

        // console.log('Unique Teachers: ', uniqueTeachers);
        uniqueTeachers.forEach(t => {
            this.assessmentUniqueCentres.forEach(c => {
                let obj = {
                    teacher: t,
                    centre: c,
                    admissionBaselineCount: this.mAssessmentData.filter(child => child.personConductingTest === t && child.centreName === c && child.type === 'Admission Baseline Assessment').length || '-',
                    dischargeAssessmentCount: this.mAssessmentData.filter(child => child.personConductingTest === t && child.centreName === c && child.type === 'Discharge Assessment').length || '-',
                    intermediateAssessmentCount: this.mAssessmentData.filter(child => child.personConductingTest === t && child.centreName === c && child.type === 'Intermediate Assessment').length || '-',
                };
                data2.push(obj);
            });

        });
      console.log('Processing Assessments Data:', data2);
        this.assessmentTableData = this.formatAssessmentTableData(data2);
      console.log('Formatted Assessment Table Data:', this.assessmentTableData);
        console.log(this.assessmentTableData)
        console.table(this.assessmentTableData.length)
    }

    processFollowUpAssessments() {
        console.log('processing Follow Up Assessments')
        let uniqueTeachers = [...new Set(this.mFAssessmentData.map(child => child.submittedBy))];
        let data2: any[] = [];

        if (this.submittedBy !== 'All' && this.submittedBy) {
            uniqueTeachers = uniqueTeachers.filter(x => x === this.submittedBy);
        }

        uniqueTeachers.forEach(t => {
            this.fassessmentUniqueCentres.forEach(c => {
                let obj = {
                    teacher: t,
                    centre: c,
                    count: this.mFAssessmentData.filter(child => child.submittedBy === t && child.centreName === c).length || '-'
                };
                data2.push(obj);
            });
        });
        // this.getFollowUpSessionsFromIndividualSessions(data2,uniqueTeachers)


        this.fassessmentTableData = this.formatTableData(data2);
    }

    getFollowUpSessionsFromIndividualSessions(data2: any[], uniqueTeachers: any[]) {
        this.mFirestore.collection<any>('Counselling/allSessions/sessions', ref => ref.where('type', '==', 'Follow-up Counselling')
            .where('date', '>=', this.startDate)
            .where('date', '<=', endOfDay(this.endDate))
        ).get()
            .pipe(takeUntil(this._destroyed$))
            .subscribe(res => {
                alert(res.docs.length)
                const followUpSessionsInIndividualSessions: any[] = res.docs.map(x => x.data())
                uniqueTeachers.forEach(t => {
                    followUpSessionsInIndividualSessions.forEach(c => {
                        let obj = {
                            teacher: t,
                            centre: c,
                            count: this.mFAssessmentData.filter(child => child.submittedBy === t && child.centreName === c).length || '-'
                        };
                        data2.push(obj);
                    });
                });


                // followUpSessionsInIndividualSessions.forEach(session => {
                //   data2.push(session)
                // })
                this.fassessmentTableData = this.formatTableData(data2)
            });
    }


    clearFilters() {
        this.selectedYear = '' as any;
        this.startDate = null as any;
        this.endDate = null as any;
        this.submittedBy = 'All';
        this.selectedCentres = [];
        this.centreControl.reset();
        this.tableData = [];
        this.groupTableData = [];
        this.assessmentTableData = [];
        this.fassessmentTableData = [];
    }


    exportexcel() {
        this.exportWithTitle('excel-table', 'Counselling Reports - Individual Sessions Count');
    }

    exportGroupexcel() {
        this.exportWithTitle('group-table', 'Counselling Reports - Group Sessions Count');
    }

    exportAssessmentExcel() {
        this.exportWithTitle('assessment-table', 'Counselling Reports - Assessment Count');
    }

    exportFAssessmentExcel() {
        this.exportWithTitle('followup-assessment-table', 'Counselling Reports - Follow-up Assessment Count');
    }

// Common function to export with title and date range
    exportWithTitle(tableId: string, titleText: string) {
        let element = document.getElementById(tableId);
        if (!element) return;

        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

        // Hide column 19 if needed
        ws['!cols'] = [];
        ws['!cols'][19] = {hidden: true};

        // Format title with date range
        const formattedStartDate = this.formatDate(this.startDate);
        const formattedEndDate = this.formatDate(this.endDate);
        const title = [
            [`${titleText} (${formattedStartDate} to ${formattedEndDate})`], // Title with date range
            [] // Empty row for spacing
        ];

        // Add title inside the worksheet
        XLSX.utils.sheet_add_aoa(ws, title, {origin: 'A1'});

        // Generate workbook and add the worksheet with a sheet name
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        const sheetName = titleText.substring(0, 31); // Excel sheet names are limited to 31 characters
        XLSX.utils.book_append_sheet(wb, ws, sheetName);

        // Save file with title and date
        XLSX.writeFile(wb, `${titleText} (${formattedStartDate} to ${formattedEndDate}).xlsx`);
    }

// Helper function to format the date (DD/MM/YYYY)
    formatDate(date: Date | any): string {
        if (!date) return 'N/A';
        const d = new Date(date);
        return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
    }


    getTotalRowCount(centres: any[]): number {
        return centres.reduce((sum, centre) => sum + (parseInt(centre.count) || 0), 0);
    }

    getTotalColumnCount(index: number, data: any[]): number {
        return data.reduce((sum, row) => sum + (parseInt(row.centres[index]?.count) || 0), 0);
    }

    getGrandTotal(data: any[]): number {
        return data.reduce((sum, row) => sum + this.getTotalRowCount(row.centres), 0);
    }

    getTotalAssessmentRowCount(centres: any[]): number {
        return centres.reduce((sum, centre) => sum + (parseInt(centre.admissionBaselineCount) || 0) + (parseInt(centre.intermediateAssessmentCount) || 0) + (parseInt(centre.dischargeAssessmentCount) || 0), 0);
    }

    getTotalAssessmentColumnCount(index: number, data: any[]): number {
        return data.reduce((sum, row) => sum + (parseInt(row.centres[index]?.admissionBaselineCount) || 0) + (parseInt(row.centres[index]?.intermediateAssessmentCount) || 0) + (parseInt(row.centres[index]?.dischargeAssessmentCount) || 0), 0);
    }

    getGrandAssessmentTotal(data: any[]): number {
        return data.reduce((sum, row) => sum + this.getTotalAssessmentRowCount(row.centres), 0);
    }

    protected readonly PermissionType = PermissionType;
}
